/**
 * Base44Route: /resources/base44
 *
 * The page itself is EcosystemPath; the steps are data in lib/ecosystemData,
 * the same as every other tool route.
 */

import EcosystemPath from "@/components/EcosystemPath";
import NotFound from "@/pages/NotFound";
import { toolPath } from "@/lib/ecosystemData";

export default function Base44Route() {
  const path = toolPath("base44");
  if (!path) return <NotFound />;
  return <EcosystemPath path={path} />;
}
